// extracted by mini-css-extract-plugin
export default {"item":"ActivityItem_item__2J9kn","paddingyx":"ActivityItem_paddingyx__Yw+Wg"};